import {Component, inject, OnInit, signal} from '@angular/core';
import {ChatComponent} from '../../../../shared/components/chat/chat.component';
import {
  ChatUserResponse,
  GetChatUserInfoControllerService,
  ProjectDetailResponse,
} from '@frontend/shared';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-project-provider-communication',
  imports: [ChatComponent],
  templateUrl: './project-provider-communication.component.html',
})
export class ProjectProviderCommunicationComponent implements OnInit {
  private readonly service = inject(GetChatUserInfoControllerService);
  private readonly route = inject(ActivatedRoute);

  protected readonly chatUserInfo = signal<ChatUserResponse | undefined>(undefined);

  ngOnInit(): void {
    const project = this.route.snapshot.data['project'] as ProjectDetailResponse;

    this.service.getChatUserInfoByProject({projectId: project.id}).subscribe((response) => {
      this.chatUserInfo.set(response);
    });
  }
}
